import { useState, useEffect } from 'react';
import { AlertTriangle, Info, XCircle, X } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const SEVERITY_CONFIG = {
  info: { bg: 'bg-blue-500/10', border: 'border-blue-500/40', text: 'text-blue-300', icon: Info, label: 'Info' },
  warning: { bg: 'bg-amber-500/10', border: 'border-amber-500/40', text: 'text-amber-300', icon: AlertTriangle, label: 'Warning' },
  critical: { bg: 'bg-rose-500/10', border: 'border-rose-500/40', text: 'text-rose-300', icon: XCircle, label: 'Critical' },
};

export function NetworkAlertBanner({ countryCode }) {
  const [alerts, setAlerts] = useState([]);
  const [dismissed, setDismissed] = useState([]);

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        const res = await fetch(`${API}/network-alerts/active`);
        const data = await res.json();
        setAlerts(data.alerts || []);
      } catch {}
    };
    fetchAlerts();
    const interval = setInterval(fetchAlerts, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const cc = countryCode?.toLowerCase();
  const visible = alerts.filter(a => {
    if (dismissed.includes(a.id)) return false;
    if (cc && a.country_codes?.length > 0) return a.country_codes.includes(cc);
    if (!cc) return true;
    return a.country_codes?.length === 0;
  });

  if (visible.length === 0) return null;

  return (
    <div className="space-y-2" data-testid="network-alert-banner">
      {visible.map(alert => {
        const config = SEVERITY_CONFIG[alert.severity] || SEVERITY_CONFIG.warning;
        const Icon = config.icon;
        return (
          <div key={alert.id} className={`${config.bg} ${config.border} border rounded-xl px-4 py-3 flex items-start gap-3`}>
            <Icon className={`w-5 h-5 ${config.text} flex-shrink-0 mt-0.5`} />
            <div className="flex-1 min-w-0">
              <p className={`${config.text} font-semibold text-sm`}>{alert.title}</p>
              {alert.description && <p className="text-slate-400 text-xs mt-1 leading-relaxed">{alert.description}</p>}
              {alert.start_date && (
                <p className="text-slate-500 text-[10px] mt-1">
                  {alert.start_date}{alert.end_date ? ` — ${alert.end_date}` : ''}
                </p>
              )}
            </div>
            <button onClick={() => setDismissed(d => [...d, alert.id])}
              className="text-slate-600 hover:text-slate-400 flex-shrink-0 transition-colors" data-testid={`dismiss-alert-${alert.id}`}>
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
